import { createApp } from 'vue'
import App from './App.vue'
import 'element-plus/dist/index.css'
import '@/assets/styles/border.css'
import '@/assets/styles/reset.css'
import ElementPlus from 'element-plus'
import router from './router'
import store from './store'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import axios from 'axios'

const app = createApp(App)
// 关键：Vue3 中通过 app.config.globalProperties 挂载全局属性
app.config.globalProperties.$axios = axios

app.use(store).use(router).use(ElementPlus, { locale: zhCn }).mount('#app')


window.addEventListener('error', function (e) {
  if (e.message.includes('ResizeObserver loop limit exceeded')) {
    e.stopPropagation();
  }
});